/**
 * WelcomeBonusPopup — one-time celebration shown when a new user is granted
 * the +50pt starter bonus. Uses StyledPopupShell for consistent look.
 */
import { Button } from "@/components/ui/button";
import { StyledPopupShell } from "@/components/common/StyledPopupShell";
import { Sparkles } from "lucide-react";
import { useWelcomeBonus, WELCOME_BONUS_POINTS } from "@/hooks/useWelcomeBonus";

export function WelcomeBonusPopup() {
  const { justAwarded, dismiss } = useWelcomeBonus();

  return (
    <StyledPopupShell
      open={justAwarded}
      onOpenChange={(o) => !o && dismiss()}
      accent="amber"
      icon={<Sparkles className="h-6 w-6" />}
      title={`Welcome — here's +${WELCOME_BONUS_POINTS} points!`}
      description="A little push to get you started. Complete a goal, join a community trail, or check in daily to earn more."
      footer={
        <Button onClick={dismiss} className="w-full sm:w-auto">
          Let's go
        </Button>
      }
    />
  );
}
